import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RenderElement } from 'shared/hoc';
import { allStandardRolesTypes } from 'shared/constants/rolesTypes';
import { Search } from 'modules/common';
import { getSearchbleIndustries, getSearchableRegions } from 'selectors/common';

const SearchBar = () => {
  const { data: regions } = useSelector(getSearchableRegions);
  const industries = useSelector(getSearchbleIndustries);

  const options = [...industries, ...regions];

  return (
    <Search
      options={options}
      getOptionLabel={(option) => option.name}
      groupBy={(option) => option.group}
    />
  );
};

export default () => {
  const location = useLocation();

  return (
    <RenderElement
      role={allStandardRolesTypes}
      condition={location.pathname.includes('search-result')}
    >
      <SearchBar />
    </RenderElement>
  );
};
